import { SubmitHandler, FieldValues, UseFormProps } from 'react-hook-form';
import { ZodSchema } from 'zod';

import Form from '@shared-forms-web/components/Form';
import { useHookForm } from '@shared-forms-web/hooks/useHookForm';

interface IFormWrapper {
	schema: ZodSchema;
	children: React.ReactNode;
	defaultValues?: UseFormProps['defaultValues'];
	onSubmit: SubmitHandler<FieldValues>;
}

export default function FormWrapper({ schema, defaultValues = {}, children, onSubmit }: IFormWrapper) {
	const form = useHookForm({
		defaultValues,
		schema,
	});

	return (
		<Form form={form} formId="form-wrapper" onSubmit={onSubmit}>
			{children}
			<button type="submit">Submit</button>
		</Form>
	);
}
